import * as api from '@/api'
const state = {
  tagsArticle: [],
  tagsAllArticle: [],
  tagsUser: [],
  roles: []
}

const getters = {

  tagsUser2 (state) {
    const list = [...state.tagsUser]
    return list.map(item => {
      item.children.map(item => {
        item.children.map(item => {
          item.disabled = true
          return item
        })
        return item
      })
      return item
    })
  },

  tagsArticle2 (state) {
    const list = [...state.tagsArticle]
    return list.map(item => {
      item.children.map(item => {
        item.children.map(item => {
          item.disabled = true
          return item
        })
        return item
      })
      return item
    })
  },

  tagsLevelUser (state) {
    const tags = { 1: [], 2: [], 3: [] }
    const list = [...state.tagsUser]
    list.map(item => {
      if (item.children && item.children.length) {
        item.children.map(item => {
          if (item.children && item.children.length) {
            item.children.map(item => {
              // delete item.children
              tags[3].push(item)
            })
          }
          // delete item.children
          tags[2].push(item)
        })
      }
      // delete item.children
      tags[1].push(item)
    })
    return tags
  },
  tagsLevelArticle (state) {
    const tags = { 1: [], 2: [], 3: [] }

    const list = [...state.tagsArticle]
    list.map(item => {
      if (item.children && item.children.length) {
        item.children.map(item => {
          if (item.children && item.children.length) {
            item.children.map(item => {
              // delete item.children
              tags[3].push(item)
            })
          }
          // delete item.children
          tags[2].push(item)
        })
      }
      // delete item.children
      tags[1].push(item)
    })
    return tags
  }
}

function fen (list) {
  let article = { 1: [], 2: [], 3: [] }
  list.map(item => {
    if (item.is_del === '0') {
      if (Array.isArray(article[item.level])) {
        article[item.level].push({
          id: item.id,
          pid: item.pid,
          value: item.id,
          label: item.tag_name,
          level: item.level,
          children: item.level < 3 ? [] : undefined,
          remark: item.remark,
          num: item.num
        })
      }
    }
  })

  let i = 3

  while (i > 1) {
    article[i].map(m => {
      article[i - 1].map(n => {
        if (m.pid === n.value) {
          n.children.push(m)
        }
      })
    })
    i--
  }

  // console.log(article[1])
  return article[1]
}


const mutations = {
  setTagsArticle: (state, tags) => {
    state.tagsArticle = tags
  },
  setTagsUser: (state, tags) => {
    state.tagsUser = tags
  },
  setTagsAllArticle: (state, tags) => {
    state.tagsAllArticle = tags
  }
}

const postData = {
  type: 2, //标签类别(1用户标签 2文章标签)，
  level: '',
  tag_name: '',
  perPage: 999,
  p: 1,
}

function arrToObj (arr) {
  const obj = {}
  arr.map(item => {
    item = {
      id: item.id,
      pid: item.pid,
      value: item.id,
      label: item.tag_name,
      level: item.level,
    }
    obj[item.id] = item
  })
  return obj
}



const actions = {
  // 模拟用户登录
  actTagsArticle ({ commit }) {
    return api.getTagList(postData).then((res) => {
      commit('setTagsArticle', fen(res.tagList))
      let obj = arrToObj(res.tagList)
      // console.log('==', obj)
      commit('setTagsAllArticle', obj)
    })
  },

  actTagsUser ({ commit }) {
    return api.getTagList({
      type: 1,
      level: '',
      tag_name: '',
      perPage: 999,
      p: 1,
    }).then((res) => {
      commit('setTagsUser', fen(res.tagList))
      console.log(state.tagsUser);
    })
  },

}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}